import React from 'react';
import { useSelector } from 'react-redux';

import headset from 'assets/img/headset.svg';
import WhatsLogo from 'assets/img/whatsappLogo.svg';

import {
  BannerWhats,
  ImgStyled,
} from './styles';

function WhatsContactBanner() {
  const tasks = useSelector(state => state.task.data);
  const userId = useSelector(state => state.task.data);
  
  const redirectMessageWhats = () => {
    let message = '';

    if (userId && tasks && tasks.length > 0) {
      if (tasks.length === 1) {
        message = `Olá!%20Tudo bem?%20Estou%20com%20dúvidas%20sobre%20o%20meu%20pedido%20de%20%23${tasks[0].task_id}%20-%20${tasks[0].service}%20e%20gostaria%20de%20mais%20informações.%20Vocês%20podem%20me%20ajudar?`;
      } else {
        message = 'Olá!%20Tudo%20bem?%20Pedi%20alguns%20serviços%20na%20plataforma%20e%20gostaria%20de%20mais%20informações.%20Os%20pedidos%20são:%0A%0A';
        tasks.forEach((task) => {
          message += `%23${task.task_id}%20-%20${task.service}%0A`;
        });
        message += '%0AVocês%20podem%20me%20ajudar?';
      }
    }

    window.open(`https://wa.me/555199800780?text=${message}`);
  };

  return (
    <BannerWhats onClick={redirectMessageWhats}>
      <div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <ImgStyled src={headset} alt="Headset" />
          <h2>Novo canal de atendimento</h2>
        </div>
        <p>
          Queremos que a sua experiência seja a melhor possível. Você pode falar com a gente sobre os seus pedidos em andamento pelo WhatsApp.
        </p>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-around',
          cursor: 'pointer',
        }}
      >
        <p style={{ marginTop: '15px', textAlign: 'center ' }}>
          Fale com o nosso suporte pelo
        </p>
        <img style={{ margin: '10px 0' }} src={WhatsLogo} alt="Logo do Whats" />
        <p>Clicando aqui.</p>
      </div>
    </BannerWhats>
  );
}

export default WhatsContactBanner;
